import React from 'react'
import PropTypes from 'prop-types'
import ReactPlaceholder from 'react-placeholder'
import Placeholder from './Placeholder'
import { TrackingStatus } from './TrackingStatus'

import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

const ProductDetails = props => {
  let pointsUsedDecimal = props.orderPaymentDetailMoneyAndPoints && props.orderPaymentDetailMoneyAndPoints.pointsUsedDecimal
  let purchaseValueDecimal = props.orderPaymentDetailMoneyAndPoints && props.orderPaymentDetailMoneyAndPoints.purchaseValueDecimal

  const veryfyCustomMessage = (props) => {
    const vendorName = props.vendorName
    const vendorType = props.vendorType

    switch (vendorType) {
      case 'Milhas':
        return `Transferência de pontos para ${vendorName}`
      default:
        return props.name
    }
  }

  return (
    <ReactPlaceholder ready={props.ready} customPlaceholder={<Placeholder />}>
      <div className='product-infos col-12 mx-0'>

        <TrackingStatus
          trackingStatus={props.trackingStatus}
          ready={props.ready}
        />
        <h2 className='txt-font-body txt-body-sm color-ui-2 mt-1'>
          {veryfyCustomMessage(props)}
        </h2>

        <div className='row mt-1 mx-0'>
          <div className='col py-half px-0 txt-subtitle'>
            <p className='txt-subtitle'>
              Valor: {props.paymentType !== 5 && props.vendorType !== 'Compra de Pontos'
                ? <CatalogCurrencyLabel value={
                  pointsUsedDecimal !== props.sellingPrice &&
                  pointsUsedDecimal !== 0
                    ? pointsUsedDecimal
                    : props.sellingPrice} />
                : ` R$ ${addZeroes(purchaseValueDecimal)}`
              }
              {props.paymentType !== 5 && props.vendorType !== 'Compra de Pontos' && purchaseValueDecimal !== 0 && props.paymentType === 2
                ? ` + R$ ${addZeroes(purchaseValueDecimal)}`
                : ''
              }
              {
                props.vendorType === 'Compra de Pontos'
                  ? <span className='d-block'>Quantidade: <CatalogCurrencyLabel value={props.quantity * props.packageSize} /></span>
                  : (props.vendorType !== 'Milhas' && props.vendorType !== 'Doação') && <strong> x {props.quantity} unidades</strong>
              }

            </p>
            {props.deliveryDate && props.name !== 'Compra de Pontos' ? (
              <p className='txt-subtitle'>
                Previsão de entrega:{' '}
                <strong>
                  {props.type !== 'EXTERNALVOUCHERVIRTUAL'
                    ? props.deliveryDate
                    : ''}
                </strong>
              </p>
            ) : (
              ''
            )}
            {props.vendorName &&
              props.vendorType !== 'Compra de Pontos' &&
              props.vendorType !== 'Milhas' ? (
                <p className='txt-subtitle'>
                  Fornecido e entregue por: <strong>{props.vendorName}</strong>
                </p>
              ) : (
                ''
              )}
          </div>
        </div>
      </div>
    </ReactPlaceholder>
  )
}

function addZeroes (value) {
  let newValue = value * 1
  newValue = newValue + ''

  let pos = newValue.indexOf('.')
  if (pos === -1) newValue = newValue + '.00'
  else {
    var integer = newValue.substring(0, pos)
    var decimals = newValue.substring(pos + 1)
    while (decimals.length < 2) decimals = decimals + '0'
    newValue = integer + ',' + decimals
  }
  return newValue.toString().replace('.', ',')
}

ProductDetails.propTypes = {
  name: PropTypes.string,
  sellingPrice: PropTypes.number,
  quantity: PropTypes.number,
  deliveryDate: PropTypes.object,
  vendorName: PropTypes.string,
  vendorType: PropTypes.string,
  ready: PropTypes.bool,
  trackingStatus: PropTypes.string,
  type: PropTypes.string,
  paymentType: PropTypes.number,
  orderPaymentDetailMoneyAndPoints: PropTypes.object,
  packageSize: PropTypes.number
}
export default ProductDetails



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderList/ProductOrderItem/ProductDetails/ProductDetails.js